import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT, footerGroups } from '../data/navigation';
import { Wordmark } from './Wordmark';
export function Footer() {
  return <footer className="w-full bg-navy text-aluminum" data-id="element-10" data-mp="32nummremu92y">
      <div className="mx-auto max-w-shell px-5 py-14 lg:px-10 lg:py-20" data-id="element-11" data-mp="32pfeg99kbdx4">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.5fr)]" data-id="element-12" data-mp="36ooaxlvzlpwd">
          <div data-id="element-13" data-mp="3ueiknul0eyce">
            <Wordmark tone="light" data-id="element-14" data-mp="3ug3etj3ewf9q" />
            <p className="rp-measure mt-6 text-[14px] leading-relaxed text-aluminum" data-id="element-15" data-mp="3uftqdzy0mg65">
              High-rake CNC lathe holders, inserts, starter kits and application
              guidance for aluminum, copper and titanium.
            </p>
            <dl className="mt-8 space-y-3 text-[14px]" data-id="element-16" data-mp="3qcxbokblj47h">
              <div className="flex flex-wrap items-baseline gap-2" data-id="element-17" data-mp="3qblyxv06am48">
                <dt className="font-mono text-[10px] tracking-label text-aluminum/70" data-id="element-18" data-mp="29y5kubu3m50a">
                  PHONE
                </dt>
                <dd data-id="element-19" data-mp="2ew6zmkkhri5y">
                  <a href={CONTACT.phoneHref} data-analytics="phone-click" data-analytics-location="footer" className="font-mono text-white underline decoration-copper decoration-1 underline-offset-4 transition-colors duration-150 ease-precise hover:text-cta" data-id="element-20" data-mp="3l9k6xg5ljtev">
                    {CONTACT.phoneLabel}
                  </a>
                </dd>
              </div>
              <div className="flex flex-wrap items-baseline gap-2" data-id="element-21" data-mp="81fpbv4sgq3o">
                <dt className="font-mono text-[10px] tracking-label text-aluminum/70" data-id="element-22" data-mp="34p8v6p2nshq">
                  EMAIL
                </dt>
                <dd data-id="element-23" data-mp="hs1yb6i02ide">
                  <a href={CONTACT.emailHref} data-analytics="email-click" data-analytics-location="footer" className="text-white underline decoration-copper decoration-1 underline-offset-4 transition-colors duration-150 ease-precise hover:text-cta" data-id="element-24" data-mp="huo6978syzw5">
                    {CONTACT.email}
                  </a>
                </dd>
              </div>
              <div data-id="element-25" data-mp="yv93xsa5fyv8">
                <dt className="font-mono text-[10px] tracking-label text-aluminum/70" data-id="element-26" data-mp="yupk260xv0ek">
                  MAILING ADDRESS
                </dt>
                <dd className="mt-1 text-aluminum" data-id="element-27" data-mp="18k0rzpc39z0v">{CONTACT.mailingAddress}</dd>
              </div>
            </dl>
          </div>

          <div className="grid grid-cols-2 gap-x-8 gap-y-10 sm:grid-cols-4" data-id="element-28" data-mp="1cmdzai6hi4zr">
            {footerGroups.map(group => <nav key={group.label} aria-label={`Footer ${group.label}`} data-id="element-29" data-mp="1hj4aar3fmaeb">
                <h2 className="font-mono text-[10px] tracking-label text-copper" data-id="element-30" data-mp="1mjihk6x7lgba">
                  {group.label.toUpperCase()}
                </h2>
                <ul className="mt-4 space-y-2.5" data-id="element-31" data-mp="1rgsfkaynz0aq">
                  {group.links.map(link => <li key={link.href} data-id="element-32" data-mp="3odhv6yxt09r5">
                      <Link to={link.href} className="inline-block py-1 text-[13.5px] leading-snug text-aluminum transition-colors duration-150 ease-precise hover:text-white" data-id="element-33" data-mp="3t9gei849z1kp">
                        {link.label}
                      </Link>
                    </li>)}
                </ul>
              </nav>)}
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-34" data-mp="1wpjv2ysauwh6">
          <p className="text-[12.5px] text-aluminum/80" data-id="element-35" data-mp="2pceb9ji339ou">
            © 2026 Robertson Precision, Inc. All rights reserved.
          </p>
          <ul className="flex items-center gap-6" data-id="element-36" data-mp="2kc8h9wocdb3l">
            <li data-id="element-37" data-mp="2kf4grpfu87u5">
              <Link to="/privacy/" className="text-[12.5px] text-aluminum/80 transition-colors duration-150 ease-precise hover:text-white" data-id="element-38" data-mp="2fego6zbynixt">
                Privacy
              </Link>
            </li>
            <li data-id="element-39" data-mp="13xgnpgfglxsp">
              <Link to="/cookie-policy/" className="text-[12.5px] text-aluminum/80 transition-colors duration-150 ease-precise hover:text-white" data-id="element-40" data-mp="1414guegzsi6w">
                Cookie Policy
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>;
}